'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var bumbag = require('bumbag');
var addWeeks = require('date-fns/addWeeks');
var addMonths = require('date-fns/addMonths');
var format = require('date-fns/format');
var isToday = require('date-fns/isToday');
var parseISO = require('date-fns/parseISO');
var faChevronRight = require('@fortawesome/pro-solid-svg-icons/faChevronRight');
var constants = require('@medipass/utils/constants');
var PaymentMethods_icons_faCcVisa = require('../PaymentMethods/icons/faCcVisa.js');
var PaymentMethods_icons_faCcMastercard = require('../PaymentMethods/icons/faCcMastercard.js');
require('@babel/runtime/helpers/extends');
require('query-string');
var reactRouterDom = require('react-router-dom');
var components_LabelWrapper = require('../components/LabelWrapper.js');
var reactFontawesome = require('@fortawesome/react-fontawesome');
require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
require('lodash/uniqueId');
require('@fortawesome/pro-solid-svg-icons/faQuestionCircle');
require('../components/DescriptionLabel.js');
require('conditional-wrap');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var addWeeks__default = /*#__PURE__*/_interopDefaultLegacy(addWeeks);
var addMonths__default = /*#__PURE__*/_interopDefaultLegacy(addMonths);
var format__default = /*#__PURE__*/_interopDefaultLegacy(format);
var isToday__default = /*#__PURE__*/_interopDefaultLegacy(isToday);
var parseISO__default = /*#__PURE__*/_interopDefaultLegacy(parseISO);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CARD_ICONS = {
  MasterCard: PaymentMethods_icons_faCcMastercard["default"],
  Visa: PaymentMethods_icons_faCcVisa["default"]
};
InstalmentPlanSchedule.defaultProps = {
  actionComponent: undefined,
  amountBalance: 0,
  amountOutstandingString: '',
  numberOfInstalments: 0,
  frequency: 0,
  futureId: undefined,
  isCompact: false,
  paymentMethod: undefined,
  paymentSchedule: [],
  showDueNow: false,
  showPlanLink: undefined,
  startDate: undefined
};
function InstalmentPlanSchedule(props) {
  var actionComponent = props.actionComponent,
      amountBalance = props.amountBalance,
      amountOutstandingString = props.amountOutstandingString,
      numberOfInstalments = props.numberOfInstalments,
      isCompact = props.isCompact,
      paymentMethod = props.paymentMethod,
      _paymentSchedule = props.paymentSchedule,
      futureId = props.futureId,
      frequency = props.frequency,
      showPlanLink = props.showPlanLink,
      showDueNow = props.showDueNow,
      startDate = props.startDate;
  var amounts = React__default["default"].useMemo(function () {
    var commonInstalmentAmount = Math.round(amountBalance / (numberOfInstalments || 1));
    var lastInstallmentAmount = amountBalance - ((numberOfInstalments || 1) - 1) * commonInstalmentAmount;
    var amounts = [];

    for (var i = 1; i <= (numberOfInstalments || 1); i++) {
      if (i === numberOfInstalments) {
        amounts.push({
          value: lastInstallmentAmount / 100
        });
        break;
      }

      amounts.push({
        value: commonInstalmentAmount / 100
      });
    }

    return amounts;
  }, [amountBalance, numberOfInstalments]);
  var paymentSchedule = _paymentSchedule;
  var hasPaidSchedule = paymentSchedule && paymentSchedule.length > 0 && paymentSchedule.some(function (schedule) {
    return schedule.status;
  });
  var hasDueNow = false;
  paymentSchedule = paymentSchedule && paymentSchedule.map(function (schedule) {
    if (showDueNow && !hasDueNow && !schedule.status) {
      hasDueNow = true;
      return _objectSpread({}, schedule, {
        isDueNow: true
      });
    }

    return schedule;
  });
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "0"
  }, /*#__PURE__*/React__default["default"].createElement("h2", {
    className: "text-xl font-bold"
  }, "Instalment plan schedule"), showPlanLink && futureId &&
  /*#__PURE__*/
  // @ts-expect-error TS(2322): Type '{ children: (string | Element)[]; use: any; ... Remove this comment to see the full error message
  React__default["default"].createElement(bumbag.Button, {
    use: reactRouterDom.Link,
    to: "/futures/view?id=" + futureId,
    palette: "secondary",
    variant: "ghost"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React__default["default"].createElement("span", null, "View plan"), /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faChevronRight.faChevronRight,
    className: "ml-2"
  })))), /*#__PURE__*/React__default["default"].createElement("hr", {
    className: "bg-neutral-dark my-4 h-px"
  }), /*#__PURE__*/React__default["default"].createElement(bumbag.Columns, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, {
    spread: isCompact ? 12 : 6
  }, paymentSchedule && paymentSchedule.length > 0 ? paymentSchedule.map(function (schedule) {
    return /*#__PURE__*/React__default["default"].createElement(components_LabelWrapper["default"], {
      key: schedule.chargeDateString // @ts-expect-error
      ,
      minBreakpoint: "mobile",
      label: isToday__default["default"](parseISO__default["default"](schedule.chargeDateString)) ? 'Today' : format__default["default"](parseISO__default["default"](schedule.chargeDateString), 'dd/MM/yyyy'),
      marginBottom: "minor-1",
      valueProps: {
        textAlign: 'right'
      }
    }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
      display: "flex",
      justifyContent: "flex-end"
    }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
      marginRight: "major-1"
    }, "$", (schedule.amount / 100).toFixed(2)), (hasPaidSchedule || hasDueNow) && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, schedule.isDueNow ? /*#__PURE__*/React__default["default"].createElement(bumbag.Tag, {
      palette: "primary",
      width: "80px"
    }, "DUE NOW") : schedule.status === constants.TRANSACTION_STATUSES.ACCEPTED || schedule.status === constants.TRANSACTION_STATUSES.APPROVED ? /*#__PURE__*/React__default["default"].createElement(bumbag.Tag, {
      palette: "successTint",
      width: "80px"
    }, "PAID") : schedule.status === constants.TRANSACTION_STATUSES.DECLINED ? /*#__PURE__*/React__default["default"].createElement(bumbag.Tag, {
      backgroundColor: "danger700",
      color: "white",
      width: "80px"
    }, "DECLINED") : /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
      width: "80px"
    }))));
  }) : amounts.map(function (amount, i) {
    var date = new Date();

    if (frequency === 'week') {
      date = addWeeks__default["default"](startDate ? parseISO__default["default"](startDate) : date, i);
    } else if (frequency === 'month') {
      date = addMonths__default["default"](startDate ? parseISO__default["default"](startDate) : date, i);
    }

    return /*#__PURE__*/React__default["default"].createElement(components_LabelWrapper["default"], {
      key: i // eslint-disable-line react/no-array-index-key
      // @ts-expect-error
      ,
      minBreakpoint: "mobile",
      label: format__default["default"](date, 'dd/MM/yyyy'),
      marginBottom: "minor-1",
      valueProps: {
        textAlign: 'right'
      }
    }, "$", amount.value.toFixed(2));
  }), paymentMethod && /*#__PURE__*/React__default["default"].createElement(components_LabelWrapper["default"], {
    label: "Billing details",
    marginTop: "major-2"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    className: "mr-2 text-base" // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    ,
    icon: CARD_ICONS[paymentMethod.cardType]
  }), ' ', /*#__PURE__*/React__default["default"].createElement("span", null, "****", paymentMethod.lastFour))), amountOutstandingString && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("hr", {
    className: "bg-neutral-dark mb-4 mt-2 h-px"
  }), /*#__PURE__*/React__default["default"].createElement(components_LabelWrapper["default"], {
    label: "Outstanding",
    valueProps: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    marginRight: "major-1"
  }, amountOutstandingString), hasPaidSchedule && /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    width: "80px"
  }))))), actionComponent && /*#__PURE__*/React__default["default"].createElement(bumbag.Columns.Column, {
    spread: isCompact ? 12 : 6,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end"
  }, actionComponent)));
}

exports["default"] = InstalmentPlanSchedule;
